export default __webpack_public_path__ + "static/media/help.987f435d.svg";